import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "c068ed24-384f-4afe-af2c-79317051d7be"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageC068ed24384f4afeAf2c79317051d7be(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageC068ed24384f4afeAf2c79317051d7be gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderBfa46c6bE5424afdBd81B176029cc594" parentTag={buildClassName("HeaderBfa46c6bE5424afdBd81B176029cc594", parentTag)} contentSlug="about-us-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      {props["main"] || <MainBdc0ef853a9f47d9B8f333010b9127b1 />}
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer3be8ec47784a4de7806b2008356ac0de" {...props} />}
    </div>
  );
}

// id: "71e3d072-80a7-4ae7-b57c-07d34235c774"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "4cb98d58-27ca-431c-9b89-03019af821dc"
export function Copyright71e3d07280a74ae7B57c07d34235c774(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright71e3d07280a74ae7B57c07d34235c774" parentTag={buildClassName("Copyright71e3d07280a74ae7B57c07d34235c774", parentTag)} {...props} />
  );
}

// id: "5cc5f5e8-c15a-415a-a86b-c84d7108779b"
// title: ""
// type: :text
// key: "as"
// parent_id: "d3d33c99-386d-4081-8a3c-8624cd23d977"
export const As5cc5f5e8C15a415aA86bC84d7108779b = "header";

// id: "482005cb-a2de-406e-ae83-b3336b8eb631"
// title: ""
// type: :text
// key: "title"
// parent_id: "5e0c8176-d045-49b3-ba5f-eb9d340e31b9"
export const Title482005cbA2de406eAe83B3336b8eb631 = "Secondary Page";

// id: "34ab7d50-4e87-48c8-81f3-1627f38ffb7c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "bfa46c6b-e542-4afd-bd81-b176029cc594"
export const ContentSlug34ab7d504e8748c881f31627f38ffb7c = "about-us-header-with-hero";

// id: "59c7bdb9-2df2-4c7b-85c9-32d2021b8613"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero59c7bdb92df24c7b85c932d2021b8613(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero59c7bdb92df24c7b85c932d2021b8613 hero`}>
      <h1 className="title">
        {props["title"] || TitleAa9a3c48A51242c9Bbac29b7c27ea557}
      </h1>
    </div>
  );
}

// id: "28f94501-fdb2-40f1-8282-315cbcdbfb1f"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "b94dfce2-b4d8-441f-b846-eda3c8839880"
export function Logo28f94501Fdb240f18282315cbcdbfb1f(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo28f94501Fdb240f18282315cbcdbfb1f" parentTag={buildClassName("Logo28f94501Fdb240f18282315cbcdbfb1f", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "533c8f81-f17d-4a06-9d82-b97be4d8bd38"
// title: ""
// type: :text
// key: "as"
// parent_id: "e57b25e9-b366-4d37-90f4-c2e5a3fe63da"
export const As533c8f81F17d4a069d82B97be4d8bd38 = "header";

// id: "c0560842-0192-4a23-8a91-f80447087ef7"
// title: ""
// type: :text
// key: "as"
// parent_id: "e626872b-0c0e-49ab-b85e-3afb0bab442d"
export const AsC056084201924a238a91F80447087ef7 = "header";

// id: "16f6ab13-75b2-4bbe-a067-eb22a2370a02"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "5bd2c7f8-da71-4182-be91-dc4a412571aa"
export function Cards16f6ab1375b24bbeA067Eb22a2370a02(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards16f6ab1375b24bbeA067Eb22a2370a02" parentTag={buildClassName("Cards16f6ab1375b24bbeA067Eb22a2370a02", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "21465849-d8b4-4ef4-b4e4-79ba8b0a42aa"
// title: "Local Partnership"
// type: :html
// key: "local-partnership-page"
// parent_id: nil
export function LocalPartnershipPage21465849D8b44ef4B4e479ba8b0a42aa(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} LocalPartnershipPage21465849D8b44ef4B4e479ba8b0a42aa gf-page-layout`}>
      {props["header"] || <ContentItem className="Header9a79e052528241cc9409F0c9214da833" parentTag={buildClassName("Header9a79e052528241cc9409F0c9214da833", parentTag)} subType="header_with_hero" contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["page-content"] || <PageContentSimplified className="PageContent4f87a0ceA40143459a8337a576a6ae0f" parentTag={buildClassName("PageContent4f87a0ceA40143459a8337a576a6ae0f", parentTag)} className="main-inner" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterDd4cb661Fde647a590deEaf25901efe0" {...props} />}
    </div>
  );
}

// id: "a50e71bd-5210-48ea-afcb-d6c981584e0b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b4ecb6e0-41ea-4352-a3b4-bb5dc703a0e5"
export function FooterA50e71bd521048eaAfcbD6c981584e0b(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterA50e71bd521048eaAfcbD6c981584e0b" {...props} />
  );
}

// id: "0980cd74-f224-4366-8e89-068ce9c8c685"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "4cb98d58-27ca-431c-9b89-03019af821dc"
export function Groupflow0980cd74F22443668e89068ce9c8c685(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow0980cd74F22443668e89068ce9c8c685" parentTag={buildClassName("Groupflow0980cd74F22443668e89068ce9c8c685", parentTag)} {...props} />
  );
}

// id: "336981b5-3d3c-4c2c-be13-bb77a7fd0eab"
// title: ""
// type: :text
// key: "className"
// parent_id: "1436b3da-40f2-4654-8541-0c21982fa527"
export const ClassName336981b53d3c4c2cBe13Bb77a7fd0eab = "public-header-with-hero secondary-page";

// id: "d2c35603-b5ee-49a8-b755-7f5a820ca366"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "e6d0089c-65e8-40ca-bcf3-beb2dde9712d"
export const NavMenuSlugD2c35603B5ee49a8B7557f5a820ca366 = "marketing-primary-nav";

// id: "3ccb9608-abba-4b3f-9fdb-036f8c66767c"
// title: ""
// type: :text
// key: "subType"
// parent_id: "bfa46c6b-e542-4afd-bd81-b176029cc594"
export const SubType3ccb9608Abba4b3f9fdb036f8c66767c = "header_with_hero";

// id: "8e6f008b-cd91-49d3-86bd-fb6ab2e3c4b0"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "16f6ab13-75b2-4bbe-a067-eb22a2370a02"
export const ButtonClass8e6f008bCd9149d386bdFb6ab2e3c4b0 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "8daecb11-771c-4c26-a815-a09b02cb3442"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader8daecb11771c4c26A815A09b02cb3442(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader8daecb11771c4c26A815A09b02cb3442 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880 parentTag="HeaderTopB7c693f875f549929b182e807af6b0a1" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero59c7bdb92df24c7b85c932d2021b8613 parentTag="Hero906899c29b5249cb80d7B9ed0c066dc7" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "b4fe6fd7-33db-49ab-879c-ee63ed1d38dd"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "b94dfce2-b4d8-441f-b846-eda3c8839880"
export function LinkedLogoB4fe6fd733db49ab879cEe63ed1d38dd(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoB4fe6fd733db49ab879cEe63ed1d38dd" parentTag={buildClassName("LinkedLogoB4fe6fd733db49ab879cEe63ed1d38dd", parentTag)} className="linked-logo" label={<Logo className="LabelCad50dd5B687429a967d7c271d589184" parentTag={buildClassName("LabelCad50dd5B687429a967d7c271d589184", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" {...props} />
  );
}

// id: "bdc0ef85-3a9f-47d9-b8f3-33010b9127b1"
// title: ""
// type: :html
// key: "main"
// parent_id: "c068ed24-384f-4afe-af2c-79317051d7be"
export function MainBdc0ef853a9f47d9B8f333010b9127b1(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainBdc0ef853a9f47d9B8f333010b9127b1`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="CardsA5bc5daeDe7d4d91B560526c74df26b1" parentTag={buildClassName("CardsA5bc5daeDe7d4d91B560526c74df26b1", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "dd34d724-72c3-453f-89c3-ca8fa724451f"
// title: ""
// type: :text
// key: "subType"
// parent_id: "0999d11d-5369-47b9-ae52-4fbd9941b723"
export const SubTypeDd34d72472c3453f89c3Ca8fa724451f = "post";

// id: "9dcb23d8-6a88-47d8-9348-3cfb5d3b0471"
// title: ""
// type: :text
// key: "class"
// parent_id: "4f87a0ce-a401-4345-9a83-37a576a6ae0f"
export const Class9dcb23d86a8847d893483cfb5d3b0471 = "main-inner";

// id: "a29c1352-0102-43dd-84d6-7c7f22517ab2"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "5bd2c7f8-da71-4182-be91-dc4a412571aa"
export function QuoteA29c1352010243dd84d67c7f22517ab2(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteA29c1352010243dd84d67c7f22517ab2" parentTag={buildClassName("QuoteA29c1352010243dd84d67c7f22517ab2", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "1436b3da-40f2-4654-8541-0c21982fa527"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "b4ecb6e0-41ea-4352-a3b4-bb5dc703a0e5"
export function Header1436b3da40f2465485410c21982fa527(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header1436b3da40f2465485410c21982fa527" parentTag={buildClassName("Header1436b3da40f2465485410c21982fa527", parentTag)} className="public-header-with-hero secondary-page" title="Public Events" subType="header_with_hero" contentSlug="public-events-header-with-hero" as="header" {...props} />
  );
}

// id: "3be8ec47-784a-4de7-806b-2008356ac0de"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "c068ed24-384f-4afe-af2c-79317051d7be"
export function Footer3be8ec47784a4de7806b2008356ac0de(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer3be8ec47784a4de7806b2008356ac0de" {...props} />
  );
}

// id: "36974232-a3d3-41c5-b93a-16db4b105934"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "06188b8f-8452-4ce8-8d83-813d2df264db"
export function Footer36974232A3d341c5B93a16db4b105934(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer36974232A3d341c5B93a16db4b105934" {...props} />
  );
}

// id: "98de568d-c609-4fd6-a748-1d5c698302a8"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "28f94501-fdb2-40f1-8282-315cbcdbfb1f"
export const LogoType98de568dC6094fd6A7481d5c698302a8 = "DEFAULT";

// id: "951518a2-c7a9-48f4-9650-0781d2c32678"
// title: ""
// type: :text
// key: "className"
// parent_id: "74a571c0-be5e-42d9-bdca-df563ae7694d"
export const ClassName951518a2C7a948f496500781d2c32678 = "public-header-with-hero secondary-page";

// id: "d6f668b2-cb57-42ab-8721-a606bdbf22a1"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "16f6ab13-75b2-4bbe-a067-eb22a2370a02"
export const PostSlugD6f668b2Cb5742ab8721A606bdbf22a1 = "home-page-cards";

// id: "06188b8f-8452-4ce8-8d83-813d2df264db"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage06188b8f84524ce88d83813d2df264db(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage06188b8f84524ce88d83813d2df264db gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderE57b25e9B3664d3790f4C2e5a3fe63da" parentTag={buildClassName("HeaderE57b25e9B3664d3790f4C2e5a3fe63da", parentTag)} as="header" className="public-header-with-hero home-page" subType="header_with_hero" contentSlug="home-header-with-hero" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack85cfd425Dc894cd3Ba55F95ada92ad0b" parentTag={buildClassName("WelcomeBack85cfd425Dc894cd3Ba55F95ada92ad0b", parentTag)} {...props} />}
      {props["main"] || <Main5bd2c7f8Da714182Be91Dc4a412571aa />}
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer36974232A3d341c5B93a16db4b105934" {...props} />}
    </div>
  );
}

// id: "9abdab4a-2c14-4978-bc5a-7a4b422dfc06"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "4cb98d58-27ca-431c-9b89-03019af821dc"
export function Logo9abdab4a2c144978Bc5a7a4b422dfc06(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo9abdab4a2c144978Bc5a7a4b422dfc06" parentTag={buildClassName("Logo9abdab4a2c144978Bc5a7a4b422dfc06", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "8a44b8c3-7365-43df-b3ea-11cc346ff975"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e626872b-0c0e-49ab-b85e-3afb0bab442d"
export const SubType8a44b8c3736543dfB3ea11cc346ff975 = "header_with_hero";

// id: "5d122e07-c6f5-47b9-a416-23e33a9b6847"
// title: ""
// type: :text
// key: "title"
// parent_id: "1436b3da-40f2-4654-8541-0c21982fa527"
export const Title5d122e07C6f547b9A41623e33a9b6847 = "Public Events";

// id: "e64d8adb-3641-41ae-a389-d8389eed0077"
// title: ""
// type: :text
// key: "as"
// parent_id: "bfa46c6b-e542-4afd-bd81-b176029cc594"
export const AsE64d8adb364141aeA389D8389eed0077 = "header";

// id: "1c62760f-0fbc-479f-b71d-921c799365aa"
// title: "Contact Us"
// type: :html
// key: "public-contact-page"
// parent_id: nil
export function PublicContactPage1c62760f0fbc479fB71d921c799365aa(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicContactPage1c62760f0fbc479fB71d921c799365aa gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderD3d33c99386d40818a3c8624cd23d977" parentTag={buildClassName("HeaderD3d33c99386d40818a3c8624cd23d977", parentTag)} as="header" contentSlug="public-contact-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content0999d11d536947b9Ae524fbd9941b723" parentTag={buildClassName("Content0999d11d536947b9Ae524fbd9941b723", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterE289c1b19a64429898b9102157d3ae9c" {...props} />}
    </div>
  );
}

// id: "95c8ac67-39c8-4676-8ba0-2273e5904db9"
// title: ""
// type: :reference
// key: "header"
// parent_id: "251c6d7e-72bf-4d6b-901e-4764ce406955"
export function Header95c8ac6739c846768ba02273e5904db9(props: any) {
  return (
    <SecondaryMarketingHeader8daecb11771c4c26A815A09b02cb3442 parentTag="Header95c8ac6739c846768ba02273e5904db9" title="Join Us" {...props} />
  );
}

// id: "68e6edb4-a123-49e6-9bd9-94474089dbc2"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "9abdab4a-2c14-4978-bc5a-7a4b422dfc06"
export const ContentSlug68e6edb4A12349e69bd994474089dbc2 = "footer-logo";

// id: "00cd5acb-61d2-4dc3-ae74-297dd317ead1"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d3d33c99-386d-4081-8a3c-8624cd23d977"
export const ContentSlug00cd5acb61d24dc3Ae74297dd317ead1 = "public-contact-header-with-hero";

// id: "1eb01307-cedf-472a-a13e-59c5aac5d86d"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "c574c171-d683-4f3c-a856-84fe5ca8b742"
export function HeroWrapper1eb01307Cedf472aA13e59c5aac5d86d(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper1eb01307Cedf472aA13e59c5aac5d86d`}>
      {props["hero"] || <Hero className="Hero4aad3cee7aff406dBa9f32a1b3791ef8" parentTag={buildClassName("Hero4aad3cee7aff406dBa9f32a1b3791ef8", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "4cb98d58-27ca-431c-9b89-03019af821dc"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter4cb98d5827ca431c9b8903019af821dc(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter4cb98d5827ca431c9b8903019af821dc footer`}>
      {props["links"] || <Navigation className="Links2adf726bA38743af8f280485d287fcf0" parentTag={buildClassName("Links2adf726bA38743af8f280485d287fcf0", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo9abdab4a2c144978Bc5a7a4b422dfc06" parentTag={buildClassName("Logo9abdab4a2c144978Bc5a7a4b422dfc06", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright71e3d07280a74ae7B57c07d34235c774" parentTag={buildClassName("Copyright71e3d07280a74ae7B57c07d34235c774", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow0980cd74F22443668e89068ce9c8c685" parentTag={buildClassName("Groupflow0980cd74F22443668e89068ce9c8c685", parentTag)} {...props} />}
    </footer>
  );
}

// id: "2adf726b-a387-43af-8f28-0485d287fcf0"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "4cb98d58-27ca-431c-9b89-03019af821dc"
export function Links2adf726bA38743af8f280485d287fcf0(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links2adf726bA38743af8f280485d287fcf0" parentTag={buildClassName("Links2adf726bA38743af8f280485d287fcf0", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "85cfd425-dc89-4cd3-ba55-f95ada92ad0b"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "06188b8f-8452-4ce8-8d83-813d2df264db"
export function WelcomeBack85cfd425Dc894cd3Ba55F95ada92ad0b(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack85cfd425Dc894cd3Ba55F95ada92ad0b" parentTag={buildClassName("WelcomeBack85cfd425Dc894cd3Ba55F95ada92ad0b", parentTag)} {...props} />
  );
}

// id: "ef3a6041-f871-4088-868e-0e4a4309c8f8"
// title: ""
// type: :text
// key: "subType"
// parent_id: "9a79e052-5282-41cc-9409-f0c9214da833"
export const SubTypeEf3a6041F8714088868e0e4a4309c8f8 = "header_with_hero";

// id: "191dc8a2-05a6-44fb-8662-4fa3a57e5047"
// title: ""
// type: :text
// key: "subType"
// parent_id: "5e0c8176-d045-49b3-ba5f-eb9d340e31b9"
export const SubType191dc8a205a644fb86624fa3a57e5047 = "header_with_hero";

// id: "45ca2a3a-945d-45f0-a2ee-4b6d0bdb7d16"
// title: ""
// type: :text
// key: "subType"
// parent_id: "1436b3da-40f2-4654-8541-0c21982fa527"
export const SubType45ca2a3a945d45f0A2ee4b6d0bdb7d16 = "header_with_hero";

// id: "8119b33b-6d92-4ebf-a3c7-78238a478178"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "4aad3cee-7aff-406d-ba9f-32a1b3791ef8"
export const PostSlug8119b33b6d924ebfA3c778238a478178 = "home-hero";

// id: "b94dfce2-b4d8-441f-b846-eda3c8839880"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogoB4fe6fd733db49ab879cEe63ed1d38dd" parentTag={buildClassName("LinkedLogoB4fe6fd733db49ab879cEe63ed1d38dd", parentTag)} className="linked-logo" label={<Logo className="LabelCad50dd5B687429a967d7c271d589184" parentTag={buildClassName("LabelCad50dd5B687429a967d7c271d589184", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="NavigationE6d0089c65e840caBcf3Beb2dde9712d" parentTag={buildClassName("NavigationE6d0089c65e840caBcf3Beb2dde9712d", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "e57b25e9-b366-4d37-90f4-c2e5a3fe63da"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "06188b8f-8452-4ce8-8d83-813d2df264db"
export function HeaderE57b25e9B3664d3790f4C2e5a3fe63da(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderE57b25e9B3664d3790f4C2e5a3fe63da" parentTag={buildClassName("HeaderE57b25e9B3664d3790f4C2e5a3fe63da", parentTag)} as="header" className="public-header-with-hero home-page" subType="header_with_hero" contentSlug="home-header-with-hero" {...props} />
  );
}

// id: "dc7fdf6d-48c5-4263-b142-63dc8fbb5940"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b1930399-e257-440c-a8ce-89bde8c03613"
export function FooterDc7fdf6d48c54263B14263dc8fbb5940(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterDc7fdf6d48c54263B14263dc8fbb5940" {...props} />
  );
}

// id: "80530b46-6845-474f-812c-d9d7641bbc48"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "15e639f1-247d-4c5e-bf39-011c340833b8"
export const ContentSlug80530b466845474f812cD9d7641bbc48 = "home-page-quote";

// id: "2c91a438-055b-4515-ae29-ac92aab1d08f"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "74a571c0-be5e-42d9-bdca-df563ae7694d"
export const ContentSlug2c91a438055b4515Ae29Ac92aab1d08f = "join-us-header-with-hero";

// id: "e8a34b96-4e79-410c-8e23-475170d9e2ab"
// title: ""
// type: :text
// key: "subType"
// parent_id: "8cd34b71-da37-4127-a11b-6b7b7ba637b9"
export const SubTypeE8a34b964e79410c8e23475170d9e2ab = "post";

// id: "b1930399-e257-440c-a8ce-89bde8c03613"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageB1930399E257440cA8ce89bde8c03613(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageB1930399E257440cA8ce89bde8c03613`} classname="gf-page-layout">
      {props["header"] || <ContentItem className="Header5e0c8176D04549b3Ba5fEb9d340e31b9" parentTag={buildClassName("Header5e0c8176D04549b3Ba5fEb9d340e31b9", parentTag)} title="Secondary Page" subType="header_with_hero" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterDc7fdf6d48c54263B14263dc8fbb5940" {...props} />}
    </div>
  );
}

// id: "dd4cb661-fde6-47a5-90de-eaf25901efe0"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "21465849-d8b4-4ef4-b4e4-79ba8b0a42aa"
export function FooterDd4cb661Fde647a590deEaf25901efe0(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterDd4cb661Fde647a590deEaf25901efe0" {...props} />
  );
}

// id: "0999d11d-5369-47b9-ae52-4fbd9941b723"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "1c62760f-0fbc-479f-b71d-921c799365aa"
export function Content0999d11d536947b9Ae524fbd9941b723(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content0999d11d536947b9Ae524fbd9941b723" parentTag={buildClassName("Content0999d11d536947b9Ae524fbd9941b723", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />
  );
}

// id: "c8da0a0a-ff96-4811-94cf-37d3e263a02b"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "9abdab4a-2c14-4978-bc5a-7a4b422dfc06"
export const LogoTypeC8da0a0aFf96481194cf37d3e263a02b = "FOOTER";

// id: "77bb37cf-54ad-4483-81d6-74c30dced8be"
// title: ""
// type: :text
// key: "subType"
// parent_id: "d3d33c99-386d-4081-8a3c-8624cd23d977"
export const SubType77bb37cf54ad448381d674c30dced8be = "header_with_hero";

// id: "3b08c45d-14f9-4162-84c6-8b1f25427c3c"
// title: ""
// type: :text
// key: "class"
// parent_id: "b4fe6fd7-33db-49ab-879c-ee63ed1d38dd"
export const Class3b08c45d14f9416284c68b1f25427c3c = "linked-logo";

// id: "b4ecb6e0-41ea-4352-a3b4-bb5dc703a0e5"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageB4ecb6e041ea4352A3b4Bb5dc703a0e5(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageB4ecb6e041ea4352A3b4Bb5dc703a0e5`}>
      {props["header"] || <ContentItem className="Header1436b3da40f2465485410c21982fa527" parentTag={buildClassName("Header1436b3da40f2465485410c21982fa527", parentTag)} className="public-header-with-hero secondary-page" title="Public Events" subType="header_with_hero" contentSlug="public-events-header-with-hero" as="header" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterA50e71bd521048eaAfcbD6c981584e0b" {...props} />}
    </div>
  );
}

// id: "5e0c8176-d045-49b3-ba5f-eb9d340e31b9"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "b1930399-e257-440c-a8ce-89bde8c03613"
export function Header5e0c8176D04549b3Ba5fEb9d340e31b9(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header5e0c8176D04549b3Ba5fEb9d340e31b9" parentTag={buildClassName("Header5e0c8176D04549b3Ba5fEb9d340e31b9", parentTag)} title="Secondary Page" subType="header_with_hero" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "b7c693f8-75f5-4992-9b18-2e807af6b0a1"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "8daecb11-771c-4c26-a815-a09b02cb3442"
export function HeaderTopB7c693f875f549929b182e807af6b0a1(props: any) {
  return (
    <DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880 parentTag="HeaderTopB7c693f875f549929b182e807af6b0a1" {...props} />
  );
}

// id: "0df71984-0738-4f3e-9ba6-839d8ddbfbe3"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "c574c171-d683-4f3c-a856-84fe5ca8b742"
export function HeaderTop0df7198407384f3e9ba6839d8ddbfbe3(props: any) {
  return (
    <DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880 parentTag="HeaderTop0df7198407384f3e9ba6839d8ddbfbe3" {...props} />
  );
}

// id: "adc56687-fd11-41bc-abc9-614226a15382"
// title: ""
// type: :text
// key: "as"
// parent_id: "74a571c0-be5e-42d9-bdca-df563ae7694d"
export const AsAdc56687Fd1141bcAbc9614226a15382 = "header";

// id: "9e22c9f4-697e-48fe-a126-67270736c678"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "8cd34b71-da37-4127-a11b-6b7b7ba637b9"
export const ContentSlug9e22c9f4697e48feA12667270736c678 = "public-faq-main-content";

// id: "8e4e8f9e-8f6e-42af-8692-e17cd2690bba"
// title: "Join Us Page"
// type: :html
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage8e4e8f9e8f6e42af8692E17cd2690bba(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} JoinUsPage8e4e8f9e8f6e42af8692E17cd2690bba`}>
      {props["header"] || <ContentItem className="Header74a571c0Be5e42d9BdcaDf563ae7694d" parentTag={buildClassName("Header74a571c0Be5e42d9BdcaDf563ae7694d", parentTag)} className="public-header-with-hero secondary-page" contentSlug="join-us-header-with-hero" as="header" subType="header_with_hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer2ffe73f2A53f4bbe93265e80979794b8" {...props} />}
    </div>
  );
}

// id: "ac0bad99-7180-4902-a181-9aeb8103eb4c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "9a79e052-5282-41cc-9409-f0c9214da833"
export const ContentSlugAc0bad9971804902A1819aeb8103eb4c = "local-partnership-header-with-hero";

// id: "f8754b80-ac9b-4495-be2d-1281723e0010"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "5e0c8176-d045-49b3-ba5f-eb9d340e31b9"
export const ContentSlugF8754b80Ac9b4495Be2d1281723e0010 = "join-us-header-with-hero";

// id: "bb7a1ba7-0b21-45ed-9370-c87e03e1f349"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1436b3da-40f2-4654-8541-0c21982fa527"
export const ContentSlugBb7a1ba70b2145ed9370C87e03e1f349 = "public-events-header-with-hero";

// id: "251c6d7e-72bf-4d6b-901e-4764ce406955"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages251c6d7e72bf4d6b901e4764ce406955(props: any) {
  return (
    <SecondaryPageB1930399E257440cA8ce89bde8c03613 parentTag="ApplicationPages251c6d7e72bf4d6b901e4764ce406955" header={<SecondaryMarketingHeader8daecb11771c4c26A815A09b02cb3442 parentTag="Header95c8ac6739c846768ba02273e5904db9" title="Join Us" />} {...props} />
  );
}

// id: "74a571c0-be5e-42d9-bdca-df563ae7694d"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "8e4e8f9e-8f6e-42af-8692-e17cd2690bba"
export function Header74a571c0Be5e42d9BdcaDf563ae7694d(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header74a571c0Be5e42d9BdcaDf563ae7694d" parentTag={buildClassName("Header74a571c0Be5e42d9BdcaDf563ae7694d", parentTag)} className="public-header-with-hero secondary-page" contentSlug="join-us-header-with-hero" as="header" subType="header_with_hero" {...props} />
  );
}

// id: "15e639f1-247d-4c5e-bf39-011c340833b8"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "06188b8f-8452-4ce8-8d83-813d2df264db"
export function Quote15e639f1247d4c5eBf39011c340833b8(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote15e639f1247d4c5eBf39011c340833b8" parentTag={buildClassName("Quote15e639f1247d4c5eBf39011c340833b8", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "b0d2361c-bc1a-4a31-a240-054447321647"
// title: ""
// type: :text
// key: "className"
// parent_id: "e57b25e9-b366-4d37-90f4-c2e5a3fe63da"
export const ClassNameB0d2361cBc1a4a31A240054447321647 = "public-header-with-hero home-page";

// id: "66570291-1761-440f-8e59-bde815fc5d35"
// title: "FAQ - Frequently Asked Questions"
// type: :html
// key: "public-faq-page"
// parent_id: nil
export function PublicFaqPage665702911761440f8e59Bde815fc5d35(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicFaqPage665702911761440f8e59Bde815fc5d35 gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderE626872b0c0e49abB85e3afb0bab442d" parentTag={buildClassName("HeaderE626872b0c0e49abB85e3afb0bab442d", parentTag)} as="header" subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content8cd34b71Da374127A11b6b7b7ba637b9" parentTag={buildClassName("Content8cd34b71Da374127A11b6b7b7ba637b9", parentTag)} subType="post" contentSlug="public-faq-main-content" className="main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer42f2bb37E7d042caAb1f01597fc2ac93" {...props} />}
    </div>
  );
}

// id: "9a79e052-5282-41cc-9409-f0c9214da833"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "21465849-d8b4-4ef4-b4e4-79ba8b0a42aa"
export function Header9a79e052528241cc9409F0c9214da833(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header9a79e052528241cc9409F0c9214da833" parentTag={buildClassName("Header9a79e052528241cc9409F0c9214da833", parentTag)} subType="header_with_hero" contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "42f2bb37-e7d0-42ca-ab1f-01597fc2ac93"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "66570291-1761-440f-8e59-bde815fc5d35"
export function Footer42f2bb37E7d042caAb1f01597fc2ac93(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer42f2bb37E7d042caAb1f01597fc2ac93" {...props} />
  );
}

// id: "68ba4640-2bc6-4f27-b943-8a5c81207f80"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "0999d11d-5369-47b9-ae52-4fbd9941b723"
export const ContentSlug68ba46402bc64f27B9438a5c81207f80 = "public-contact-main-content";

// id: "cad50dd5-b687-429a-967d-7c271d589184"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "b4fe6fd7-33db-49ab-879c-ee63ed1d38dd"
export function LabelCad50dd5B687429a967d7c271d589184(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelCad50dd5B687429a967d7c271d589184" parentTag={buildClassName("LabelCad50dd5B687429a967d7c271d589184", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "7afdca97-4ea5-4eee-a52e-5f78f439da2e"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e57b25e9-b366-4d37-90f4-c2e5a3fe63da"
export const SubType7afdca974ea54eeeA52e5f78f439da2e = "header_with_hero";

// id: "aa9a3c48-a512-42c9-bbac-29b7c27ea557"
// title: ""
// type: :text
// key: "title"
// parent_id: "59c7bdb9-2df2-4c7b-85c9-32d2021b8613"
export const TitleAa9a3c48A51242c9Bbac29b7c27ea557 = "Default Title";

// id: "e6d0089c-65e8-40ca-bcf3-beb2dde9712d"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "b94dfce2-b4d8-441f-b846-eda3c8839880"
export function NavigationE6d0089c65e840caBcf3Beb2dde9712d(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationE6d0089c65e840caBcf3Beb2dde9712d" parentTag={buildClassName("NavigationE6d0089c65e840caBcf3Beb2dde9712d", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "2d544723-f849-433f-a5d6-704449447b34"
// title: ""
// type: :text
// key: "as"
// parent_id: "9a79e052-5282-41cc-9409-f0c9214da833"
export const As2d544723F849433fA5d6704449447b34 = "header";

// id: "61dd2185-d04b-4add-a242-2980fb40efb3"
// title: ""
// type: :text
// key: "as"
// parent_id: "5e0c8176-d045-49b3-ba5f-eb9d340e31b9"
export const As61dd2185D04b4addA2422980fb40efb3 = "header";

// id: "410981a0-69e9-4098-a73f-fbb267029dee"
// title: ""
// type: :text
// key: "as"
// parent_id: "1436b3da-40f2-4654-8541-0c21982fa527"
export const As410981a069e94098A73fFbb267029dee = "header";

// id: "e289c1b1-9a64-4298-98b9-102157d3ae9c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "1c62760f-0fbc-479f-b71d-921c799365aa"
export function FooterE289c1b19a64429898b9102157d3ae9c(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="FooterE289c1b19a64429898b9102157d3ae9c" {...props} />
  );
}

// id: "bfa46c6b-e542-4afd-bd81-b176029cc594"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "c068ed24-384f-4afe-af2c-79317051d7be"
export function HeaderBfa46c6bE5424afdBd81B176029cc594(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderBfa46c6bE5424afdBd81B176029cc594" parentTag={buildClassName("HeaderBfa46c6bE5424afdBd81B176029cc594", parentTag)} contentSlug="about-us-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "e626872b-0c0e-49ab-b85e-3afb0bab442d"
// title: "Contact Header Clone CEM6GZI2IPRP07Y1J"
// type: :gf_preset
// key: "header"
// parent_id: "66570291-1761-440f-8e59-bde815fc5d35"
export function HeaderE626872b0c0e49abB85e3afb0bab442d(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderE626872b0c0e49abB85e3afb0bab442d" parentTag={buildClassName("HeaderE626872b0c0e49abB85e3afb0bab442d", parentTag)} as="header" subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" {...props} />
  );
}

// id: "75a55c7b-9a17-4072-b4a5-8f6401562019"
// title: ""
// type: :text
// key: "title"
// parent_id: "906899c2-9b52-49cb-80d7-b9ed0c066dc7"
export const Title75a55c7b9a174072B4a58f6401562019 = "Secondary Marketing Title 2";

// id: "9e33f554-d725-487c-a235-5dfb3ad87a18"
// title: ""
// type: :text
// key: "className"
// parent_id: "d3d33c99-386d-4081-8a3c-8624cd23d977"
export const ClassName9e33f554D725487cA2355dfb3ad87a18 = "public-header-with-hero secondary-page";

// id: "4aad3cee-7aff-406d-ba9f-32a1b3791ef8"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "1eb01307-cedf-472a-a13e-59c5aac5d86d"
export function Hero4aad3cee7aff406dBa9f32a1b3791ef8(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero4aad3cee7aff406dBa9f32a1b3791ef8" parentTag={buildClassName("Hero4aad3cee7aff406dBa9f32a1b3791ef8", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "8cd34b71-da37-4127-a11b-6b7b7ba637b9"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "66570291-1761-440f-8e59-bde815fc5d35"
export function Content8cd34b71Da374127A11b6b7b7ba637b9(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content8cd34b71Da374127A11b6b7b7ba637b9" parentTag={buildClassName("Content8cd34b71Da374127A11b6b7b7ba637b9", parentTag)} subType="post" contentSlug="public-faq-main-content" className="main-content" {...props} />
  );
}

// id: "4f87a0ce-a401-4345-9a83-37a576a6ae0f"
// title: "Local Partnership - Page Content"
// type: :gf_preset
// key: "page-content"
// parent_id: "21465849-d8b4-4ef4-b4e4-79ba8b0a42aa"
export function PageContent4f87a0ceA40143459a8337a576a6ae0f(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="PageContent4f87a0ceA40143459a8337a576a6ae0f" parentTag={buildClassName("PageContent4f87a0ceA40143459a8337a576a6ae0f", parentTag)} className="main-inner" {...props} />
  );
}

// id: "a5bc5dae-de7d-4d91-b560-526c74df26b1"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "bdc0ef85-3a9f-47d9-b8f3-33010b9127b1"
export function CardsA5bc5daeDe7d4d91B560526c74df26b1(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsA5bc5daeDe7d4d91B560526c74df26b1" parentTag={buildClassName("CardsA5bc5daeDe7d4d91B560526c74df26b1", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "4e550e23-2c97-43f5-aed5-48dbdd0ac1b5"
// title: ""
// type: :text
// key: "subType"
// parent_id: "74a571c0-be5e-42d9-bdca-df563ae7694d"
export const SubType4e550e232c9743f5Aed548dbdd0ac1b5 = "header_with_hero";

// id: "63e2474f-6613-48fc-9993-37b917ebc232"
// title: ""
// type: :text
// key: "className"
// parent_id: "e626872b-0c0e-49ab-b85e-3afb0bab442d"
export const ClassName63e2474f661348fc999337b917ebc232 = "public-header-with-hero secondary-page";

// id: "29704bb4-712a-45f8-bdac-43f44588cf9f"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "cad50dd5-b687-429a-967d-7c271d589184"
export const LogoType29704bb4712a45f8Bdac43f44588cf9f = "DEFAULT";

// id: "c574c171-d683-4f3c-a856-84fe5ca8b742"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "06188b8f-8452-4ce8-8d83-813d2df264db"
export function HeaderWrapperC574c171D6834f3cA85684fe5ca8b742(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapperC574c171D6834f3cA85684fe5ca8b742`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880 parentTag="HeaderTop0df7198407384f3e9ba6839d8ddbfbe3" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper1eb01307Cedf472aA13e59c5aac5d86d />}
    </div>
  );
}

// id: "5bd2c7f8-da71-4182-be91-dc4a412571aa"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "06188b8f-8452-4ce8-8d83-813d2df264db"
export function Main5bd2c7f8Da714182Be91Dc4a412571aa(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main5bd2c7f8Da714182Be91Dc4a412571aa`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards16f6ab1375b24bbeA067Eb22a2370a02" parentTag={buildClassName("Cards16f6ab1375b24bbeA067Eb22a2370a02", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
      {props["quote"] || <PageQuote className="QuoteA29c1352010243dd84d67c7f22517ab2" parentTag={buildClassName("QuoteA29c1352010243dd84d67c7f22517ab2", parentTag)} contentSlug="home-page-quote" {...props} />}
    </main>
  );
}

// id: "a91455a8-f0c8-4d51-8fcd-b31e3d45ded8"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "2adf726b-a387-43af-8f28-0485d287fcf0"
export const NavMenuSlugA91455a8F0c84d518fcdB31e3d45ded8 = "footer-nav";

// id: "d8044a26-c936-4f4b-8309-37c5d7172f96"
// title: ""
// type: :text
// key: "className"
// parent_id: "0999d11d-5369-47b9-ae52-4fbd9941b723"
export const ClassNameD8044a26C9364f4b830937c5d7172f96 = "main-content";

// id: "44038198-6352-4987-a777-1cd6ba5fc15a"
// title: ""
// type: :text
// key: "class"
// parent_id: "e6d0089c-65e8-40ca-bcf3-beb2dde9712d"
export const Class4403819863524987A7771cd6ba5fc15a = "navigation";

// id: "f187ad0b-e982-4e2f-8f4b-f6dd6eb25b8f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "a5bc5dae-de7d-4d91-b560-526c74df26b1"
export const PostSlugF187ad0bE9824e2f8f4bF6dd6eb25b8f = "about-us-cards";

// id: "eeefcc3f-b4ca-41e9-9779-f8f445ec3876"
// title: ""
// type: :text
// key: "title"
// parent_id: "8daecb11-771c-4c26-a815-a09b02cb3442"
export const TitleEeefcc3fB4ca41e99779F8f445ec3876 = "Secondary Marketing Title 1";

// id: "906899c2-9b52-49cb-80d7-b9ed0c066dc7"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "8daecb11-771c-4c26-a815-a09b02cb3442"
export function Hero906899c29b5249cb80d7B9ed0c066dc7(props: any) {
  return (
    <SecondaryMarketingHero59c7bdb92df24c7b85c932d2021b8613 parentTag="Hero906899c29b5249cb80d7B9ed0c066dc7" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "30e920a8-5f08-4e10-8f16-4d8eb820d752"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e57b25e9-b366-4d37-90f4-c2e5a3fe63da"
export const ContentSlug30e920a85f084e108f164d8eb820d752 = "home-header-with-hero";

// id: "884631dc-3a59-41e0-b51c-799b35a04754"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e626872b-0c0e-49ab-b85e-3afb0bab442d"
export const ContentSlug884631dc3a5941e0B51c799b35a04754 = "public-faq-header-with-hero";

// id: "ee82bc26-9ddb-42e5-b131-a76a391241fb"
// title: ""
// type: :text
// key: "url"
// parent_id: "b4fe6fd7-33db-49ab-879c-ee63ed1d38dd"
export const UrlEe82bc269ddb42e5B131A76a391241fb = "/";

// id: "41b3f48a-2b14-4b12-9f20-f43ddced4e9a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "cad50dd5-b687-429a-967d-7c271d589184"
export const ContentSlug41b3f48a2b144b129f20F43ddced4e9a = "header-logo";

// id: "d3d33c99-386d-4081-8a3c-8624cd23d977"
// title: "Contact Header"
// type: :gf_preset
// key: "header"
// parent_id: "1c62760f-0fbc-479f-b71d-921c799365aa"
export function HeaderD3d33c99386d40818a3c8624cd23d977(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderD3d33c99386d40818a3c8624cd23d977" parentTag={buildClassName("HeaderD3d33c99386d40818a3c8624cd23d977", parentTag)} as="header" contentSlug="public-contact-header-with-hero" subType="header_with_hero" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "2ffe73f2-a53f-4bbe-9326-5e80979794b8"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "8e4e8f9e-8f6e-42af-8692-e17cd2690bba"
export function Footer2ffe73f2A53f4bbe93265e80979794b8(props: any) {
  return (
    <DefaultFooter4cb98d5827ca431c9b8903019af821dc parentTag="Footer2ffe73f2A53f4bbe93265e80979794b8" {...props} />
  );
}

// id: "adbccd76-0332-464d-a7f5-b1d3f517ecda"
// title: ""
// type: :text
// key: "className"
// parent_id: "bfa46c6b-e542-4afd-bd81-b176029cc594"
export const ClassNameAdbccd760332464dA7f5B1d3f517ecda = "public-header-with-hero secondary-page";

// id: "53c1a66d-0071-407f-97af-eec568026290"
// title: ""
// type: :text
// key: "className"
// parent_id: "9a79e052-5282-41cc-9409-f0c9214da833"
export const ClassName53c1a66d0071407f97afEec568026290 = "public-header-with-hero secondary-page";

// id: "febddaec-3f79-4429-8ade-ecfa68edb724"
// title: ""
// type: :text
// key: "className"
// parent_id: "5e0c8176-d045-49b3-ba5f-eb9d340e31b9"
export const ClassNameFebddaec3f7944298adeEcfa68edb724 = "public-header-with-hero secondary-page";

// id: "64f2b88d-2a73-4464-9bc8-c88e01ba4d32"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "a29c1352-0102-43dd-84d6-7c7f22517ab2"
export const ContentSlug64f2b88d2a7344649bc8C88e01ba4d32 = "home-page-quote";

// id: "0fa5f1bb-30c0-42d7-9430-b546ffab9206"
// title: ""
// type: :text
// key: "className"
// parent_id: "8cd34b71-da37-4127-a11b-6b7b7ba637b9"
export const ClassName0fa5f1bb30c042d79430B546ffab9206 = "main-content";

// id: "bd45a2e2-76a7-4997-9458-f7181fc70b61"
// title: ""
// type: :text
// key: "title"
// parent_id: "95c8ac67-39c8-4676-8ba0-2273e5904db9"
export const TitleBd45a2e276a749979458F7181fc70b61 = "Join Us";

const Components = {
  AboutUsPageC068ed24384f4afeAf2c79317051d7be,
  Copyright71e3d07280a74ae7B57c07d34235c774,
  As5cc5f5e8C15a415aA86bC84d7108779b,
  Title482005cbA2de406eAe83B3336b8eb631,
  ContentSlug34ab7d504e8748c881f31627f38ffb7c,
  SecondaryMarketingHero59c7bdb92df24c7b85c932d2021b8613,
  Logo28f94501Fdb240f18282315cbcdbfb1f,
  As533c8f81F17d4a069d82B97be4d8bd38,
  AsC056084201924a238a91F80447087ef7,
  Cards16f6ab1375b24bbeA067Eb22a2370a02,
  LocalPartnershipPage21465849D8b44ef4B4e479ba8b0a42aa,
  FooterA50e71bd521048eaAfcbD6c981584e0b,
  Groupflow0980cd74F22443668e89068ce9c8c685,
  ClassName336981b53d3c4c2cBe13Bb77a7fd0eab,
  NavMenuSlugD2c35603B5ee49a8B7557f5a820ca366,
  SubType3ccb9608Abba4b3f9fdb036f8c66767c,
  ButtonClass8e6f008bCd9149d386bdFb6ab2e3c4b0,
  SecondaryMarketingHeader8daecb11771c4c26A815A09b02cb3442,
  LinkedLogoB4fe6fd733db49ab879cEe63ed1d38dd,
  MainBdc0ef853a9f47d9B8f333010b9127b1,
  SubTypeDd34d72472c3453f89c3Ca8fa724451f,
  Class9dcb23d86a8847d893483cfb5d3b0471,
  QuoteA29c1352010243dd84d67c7f22517ab2,
  Header1436b3da40f2465485410c21982fa527,
  Footer3be8ec47784a4de7806b2008356ac0de,
  Footer36974232A3d341c5B93a16db4b105934,
  LogoType98de568dC6094fd6A7481d5c698302a8,
  ClassName951518a2C7a948f496500781d2c32678,
  PostSlugD6f668b2Cb5742ab8721A606bdbf22a1,
  HomePage06188b8f84524ce88d83813d2df264db,
  Logo9abdab4a2c144978Bc5a7a4b422dfc06,
  SubType8a44b8c3736543dfB3ea11cc346ff975,
  Title5d122e07C6f547b9A41623e33a9b6847,
  AsE64d8adb364141aeA389D8389eed0077,
  PublicContactPage1c62760f0fbc479fB71d921c799365aa,
  Header95c8ac6739c846768ba02273e5904db9,
  ContentSlug68e6edb4A12349e69bd994474089dbc2,
  ContentSlug00cd5acb61d24dc3Ae74297dd317ead1,
  HeroWrapper1eb01307Cedf472aA13e59c5aac5d86d,
  DefaultFooter4cb98d5827ca431c9b8903019af821dc,
  Links2adf726bA38743af8f280485d287fcf0,
  WelcomeBack85cfd425Dc894cd3Ba55F95ada92ad0b,
  SubTypeEf3a6041F8714088868e0e4a4309c8f8,
  SubType191dc8a205a644fb86624fa3a57e5047,
  SubType45ca2a3a945d45f0A2ee4b6d0bdb7d16,
  PostSlug8119b33b6d924ebfA3c778238a478178,
  DefaultHeaderTopB94dfce2B4d8441fB846Eda3c8839880,
  HeaderE57b25e9B3664d3790f4C2e5a3fe63da,
  FooterDc7fdf6d48c54263B14263dc8fbb5940,
  ContentSlug80530b466845474f812cD9d7641bbc48,
  ContentSlug2c91a438055b4515Ae29Ac92aab1d08f,
  SubTypeE8a34b964e79410c8e23475170d9e2ab,
  SecondaryPageB1930399E257440cA8ce89bde8c03613,
  FooterDd4cb661Fde647a590deEaf25901efe0,
  Content0999d11d536947b9Ae524fbd9941b723,
  LogoTypeC8da0a0aFf96481194cf37d3e263a02b,
  SubType77bb37cf54ad448381d674c30dced8be,
  Class3b08c45d14f9416284c68b1f25427c3c,
  PublicEventsPageB4ecb6e041ea4352A3b4Bb5dc703a0e5,
  Header5e0c8176D04549b3Ba5fEb9d340e31b9,
  HeaderTopB7c693f875f549929b182e807af6b0a1,
  HeaderTop0df7198407384f3e9ba6839d8ddbfbe3,
  AsAdc56687Fd1141bcAbc9614226a15382,
  ContentSlug9e22c9f4697e48feA12667270736c678,
  JoinUsPage8e4e8f9e8f6e42af8692E17cd2690bba,
  ContentSlugAc0bad9971804902A1819aeb8103eb4c,
  ContentSlugF8754b80Ac9b4495Be2d1281723e0010,
  ContentSlugBb7a1ba70b2145ed9370C87e03e1f349,
  ApplicationPages251c6d7e72bf4d6b901e4764ce406955,
  Header74a571c0Be5e42d9BdcaDf563ae7694d,
  Quote15e639f1247d4c5eBf39011c340833b8,
  ClassNameB0d2361cBc1a4a31A240054447321647,
  PublicFaqPage665702911761440f8e59Bde815fc5d35,
  Header9a79e052528241cc9409F0c9214da833,
  Footer42f2bb37E7d042caAb1f01597fc2ac93,
  ContentSlug68ba46402bc64f27B9438a5c81207f80,
  LabelCad50dd5B687429a967d7c271d589184,
  SubType7afdca974ea54eeeA52e5f78f439da2e,
  TitleAa9a3c48A51242c9Bbac29b7c27ea557,
  NavigationE6d0089c65e840caBcf3Beb2dde9712d,
  As2d544723F849433fA5d6704449447b34,
  As61dd2185D04b4addA2422980fb40efb3,
  As410981a069e94098A73fFbb267029dee,
  FooterE289c1b19a64429898b9102157d3ae9c,
  HeaderBfa46c6bE5424afdBd81B176029cc594,
  HeaderE626872b0c0e49abB85e3afb0bab442d,
  Title75a55c7b9a174072B4a58f6401562019,
  ClassName9e33f554D725487cA2355dfb3ad87a18,
  Hero4aad3cee7aff406dBa9f32a1b3791ef8,
  Content8cd34b71Da374127A11b6b7b7ba637b9,
  PageContent4f87a0ceA40143459a8337a576a6ae0f,
  CardsA5bc5daeDe7d4d91B560526c74df26b1,
  SubType4e550e232c9743f5Aed548dbdd0ac1b5,
  ClassName63e2474f661348fc999337b917ebc232,
  LogoType29704bb4712a45f8Bdac43f44588cf9f,
  HeaderWrapperC574c171D6834f3cA85684fe5ca8b742,
  Main5bd2c7f8Da714182Be91Dc4a412571aa,
  NavMenuSlugA91455a8F0c84d518fcdB31e3d45ded8,
  ClassNameD8044a26C9364f4b830937c5d7172f96,
  Class4403819863524987A7771cd6ba5fc15a,
  PostSlugF187ad0bE9824e2f8f4bF6dd6eb25b8f,
  TitleEeefcc3fB4ca41e99779F8f445ec3876,
  Hero906899c29b5249cb80d7B9ed0c066dc7,
  ContentSlug30e920a85f084e108f164d8eb820d752,
  ContentSlug884631dc3a5941e0B51c799b35a04754,
  UrlEe82bc269ddb42e5B131A76a391241fb,
  ContentSlug41b3f48a2b144b129f20F43ddced4e9a,
  HeaderD3d33c99386d40818a3c8624cd23d977,
  Footer2ffe73f2A53f4bbe93265e80979794b8,
  ClassNameAdbccd760332464dA7f5B1d3f517ecda,
  ClassName53c1a66d0071407f97afEec568026290,
  ClassNameFebddaec3f7944298adeEcfa68edb724,
  ContentSlug64f2b88d2a7344649bc8C88e01ba4d32,
  ClassName0fa5f1bb30c042d79430B546ffab9206,
  TitleBd45a2e276a749979458F7181fc70b61
}

export default Components;